import template from './home.html';
import controller from './home.controller';
import './home.scss';

let homeComponent = {
  bindings: {},
  template,
  controllerAs: 'vm',
  controller
};

export default homeComponent;



// WEBPACK FOOTER //
// ./client/app/pages/home/home.component.js